/* React Higher Order Component which fetches all available short course licenses
    Child (InnerComponent) will only render once short course licenses are successfully fetched.
    child will receive props: {
        licenses: PropTypes.array,
        fatalError: PropTypes.object,
    }

*/

import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');

const ShortCourseActions = require('../../actions/ShortCourseActions');
const ShortCourseStore = require('../../stores/ShortCourseStore');
import LoadingMainContent from '../loading/LoadingMainContent';
import ErrorBox from '../common/ErrorBox';
const ReactUtil = require('../../util/ReactUtil');

const propTypes = {
    forceRefreshOnMount: PropTypes.bool,
    hideLoadingIcon: PropTypes.bool
};

const defaultProps = {
    hideLoadingIcon: false
};

export default function withAllShortCourseLicenseData(WrappedComponent) {
    class WithAllShortCourseLicenseData extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                licenses: null, // only render children once licenses are fetched via componentDidMount
                getActionId: null,
                fatalError: null
            }

            this.unsubscribes = [ShortCourseStore.listen(this.onShortCourseStoreChange.bind(this))];
        }

        componentDidMount() {
            const actionId = uuid.v4();
            this.setState({ getActionId: actionId }, () => {
                ShortCourseActions.getShortCourseLicenses(actionId);
            });
        }

        componentWillUnmount() {
            this.unsubscribes.forEach(u => u());
        }

        onShortCourseStoreChange(newState) {
            let updatedState = { licenses: Object.values(newState.courseLicenses) };
            if (newState.action.id === this.state.getActionId) {
                updatedState = { ...updatedState, getActionId: null };
                if (!!newState.action.error) {
                    updatedState = { ...updatedState, fatalError: newState.action.error };
                }
            }

            this.setState({
                ...updatedState,
            });
        }

        render() {
            if (this.state.fatalError) {
                return <ErrorBox error={this.state.fatalError} allowStackTrace />;
            }

            if (!this.state.licenses) {
                if (this.props.hideLoadingIcon) {
                    return null;
                }
                else {
                    return <LoadingMainContent />;
                }
            }

            return (
                <WrappedComponent
                    {...this.props}
                    licenses={this.state.licenses}
                />
            );
        }
    }

    WithAllShortCourseLicenseData.propTypes = propTypes;
    WithAllShortCourseLicenseData.defaultProps = defaultProps;
    WithAllShortCourseLicenseData.displayName = `WithAllShortCourseLicenseData(${ReactUtil.getComponentDisplayName(WrappedComponent)})`
    return WithAllShortCourseLicenseData;
}
